var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fa-icon',{attrs:{"icon":"arrow-right","transform":{ rotate: -45 },"title":_vm.$gettext('height_diff_up')}})
}
var staticRenderFns = []

export { render, staticRenderFns }